import { useSelector } from "react-redux";

import { useCheckout } from "@/components/Checkout/useCheckout.hook";
import { isLoading } from "@/redux/modules/api/data/checkout/payment/payment.selectors";

import { SubmitPaymentButtonComponent } from "./submitPaymentButton.component";

const SubmitPaymentButton = () => {
    const loading = useSelector(isLoading);

    const { cartLoading } = useCheckout();

    return <SubmitPaymentButtonComponent loading={loading || cartLoading} />;
};

export { SubmitPaymentButton };
